
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-ssm/support",
      function () {
        return require("private-next-pages/about-ssm/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-ssm/support"])
      });
    }
  